import { addDiastereotopicMissingChirality } from 'openchemlib-utils';
import { predictCarbon, } from '../prediction/predictCarbon';
import { buildAssignments } from './utils/buildAssignments';
import generateID from './utils/generateID';
function checkAtomsAndDiaIDs(signals) {
    for (const signal of signals) {
        if (!signal.atoms)
            throw new Error('signal has not atoms property');
        if (!signal.diaIDs)
            throw new Error('signal has not diaIDs property');
        if (!signal.nbAtoms)
            throw new Error('signal has not nbAtoms property');
    }
}
function checkIntegration(ranges) {
    for (let range of ranges) {
        if (range.integration === undefined)
            range.integration = 0;
    }
    return ranges;
}
export async function get13CAssignments(ranges, molecule, options = {}) {
    let { restrictionByCS = {}, minScore = 1, maxSolutions = 10, nbAllowedUnAssigned = 0, timeout = 6000, predictionOptions = {}, } = options;
    if (!molecule) {
        throw new Error('It is needed a OCL molecule instance to assign');
    }
    addDiastereotopicMissingChirality(molecule);
    const { joinedSignals } = await predictCarbon(molecule, predictionOptions);
    checkAtomsAndDiaIDs(joinedSignals);
    const copyRanges = checkIntegration(ranges);
    const targets = {};
    for (const range of copyRanges) {
        const { id = generateID() } = range;
        targets[id] = JSON.parse(JSON.stringify(range));
    }
    return buildAssignments({
        restrictionByCS,
        timeout,
        minScore,
        nbAllowedUnAssigned,
        maxSolutions,
        targets,
        joinedSignals,
        useIntegrationRestriction: false,
    });
}
//# sourceMappingURL=get13CAssignments.js.map